import React from 'react';

import {
  TransitLocationTrack,
  TransitLocationEmptyState,
  VisibilityAppTrackPill,
} from './activity-location-update.style';
import NoteSection from '../note-section/note-section';
import { TRACKING_EVENT_TYPES } from '../../../../../constants';
import ActivityWrapper from '../activity-wrapper';
import trackingEventShape from '../../../../../shapes/tracking-event-activity';
import { formatUsername } from '../../../../../utils/common';

/**
 * The transit tracker locations component
 * @param {object} params - Object containing props
 * @param {object} lastTrackingEvent - Last Tracking Event to show
 * @return {element} - The Shipment Stops card component
 */
const ActivityLocationUpdate = ({ lastTrackingEvent }) => {
  /**
   * Gets header text for a location update
   * @return {element}
   */
  const getHeader = () => {
    if (lastTrackingEvent.eventType === TRACKING_EVENT_TYPES.automaticTrack) {
      return [
        { text: `${lastTrackingEvent.initiatorName} automatically tracked a location` },
        { text: 'Driver Location', descriptor: `${lastTrackingEvent.driverCity}, ${lastTrackingEvent.driverState}` },
      ];
    } if (lastTrackingEvent.eventType === TRACKING_EVENT_TYPES.manualTrack) {
      return [
        { text: `${formatUsername(lastTrackingEvent.initiatorName)} tracked a location` },
        { text: 'Driver Location', descriptor: `${lastTrackingEvent.driverCity}, ${lastTrackingEvent.driverState}` },
      ];
    }
    return null;
  };

  /**
   * Get child section for this activity
   * @return {element}
   */
  const getChildSection = () => {
    if (lastTrackingEvent.eventType === TRACKING_EVENT_TYPES.manualTrack) {
      return (<NoteSection note={lastTrackingEvent.note} />);
    } if (lastTrackingEvent.eventType === TRACKING_EVENT_TYPES.automaticTrack) {
      return (<VisibilityAppTrackPill>Visibility App Track</VisibilityAppTrackPill>);
    }
    return null;
  };

  if (lastTrackingEvent?.eventType !== TRACKING_EVENT_TYPES.manualTrack
      && lastTrackingEvent?.eventType !== TRACKING_EVENT_TYPES.automaticTrack) {
    return <TransitLocationEmptyState>No location tracked yet on this load</TransitLocationEmptyState>;
  }
  return (
    <TransitLocationTrack>
      <ActivityWrapper
        headerContent={getHeader()}
        timestamp={lastTrackingEvent.eventTime}
        backgroundWarn={false}
        descriptorWarn={false}
        type={lastTrackingEvent.eventType}
        testId="activity-location-update"
      >
        {getChildSection()}
      </ActivityWrapper>
    </TransitLocationTrack>
  );
};

ActivityLocationUpdate.propTypes = {
  lastTrackingEvent: trackingEventShape,
};

ActivityLocationUpdate.defaultProps = {
  lastTrackingEvent: null,
};

export default ActivityLocationUpdate;
